<template>
  <div class="w-100 py-3">
    <!-- بخش اضافه شده: نمایش عنوان و توضیحات -->
    <div class="mb-4 px-4" v-if="title || description">
      <h3 v-if="title" class="text-center font-weight-bold mb-3">
        {{ title }}
      </h3>
      <p
        v-if="description"
        class="text-justify mb-0"
        style="white-space: pre-line; line-height: 1.8"
      >
        {{ description }}
      </p>
    </div>
    <div class="flipbook-viewport">
      <div class="container position-relative px-0">
        <div class="nav-controls" v-if="info && info.length > 1">
          <v-btn
            fab
            x-small
            color="white"
            class="nav-btn next"
            @click="prevPage"
            :disabled="currentPage === 1"
          >
            <v-icon color="black">mdi-chevron-right</v-icon>
          </v-btn>

          <v-btn
            fab
            x-small
            color="white"
            class="nav-btn prev"
            @click="nextPage"
            :disabled="currentPage === info.length"
          >
            <v-icon color="black">mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <div id="flipbook" class="mx-auto" v-if="info && info.length">
          <!-- صفحه اول (جلد) -->
          <div class="hard">
            <v-img height="100%" :src="info[0].url" position="center center" />
          </div>

          <!-- سایر صفحات (بدون تکرار صفحه اول) -->
          <div
            v-for="(item, index) in info.slice(1)"
            :key="'page-' + index"
            class="sheet"
          >
            <v-img height="100%" :src="item.url" position="center center" />
          </div>
        </div>

        <div v-else class="text-center p-5">در حال بارگذاری تصاویر...</div>

        <div class="page-number-indicator" v-if="info && info.length">
          {{ persian(currentPage) }} از {{ persian(info.length) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "turnViewer",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    info: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.initTurnJs();
  },
  methods: {
    async initTurnJs() {
      try {
        await this.loadDependencies();
        this.$nextTick(() => {
          setTimeout(() => {
            this.runTurnPlugin();
          }, 300);
        });
      } catch (error) {
        console.error("خطا در آماده‌سازی کتابخانه:", error);
      }
    },

    async loadDependencies() {
      if (!window.jQuery) {
        await this.loadScript("/js/extras/jquery.min.1.7.js");
      }
      await this.loadScript("/js/extras/modernizr.2.5.3.min.js");

      const isModern = window.Modernizr && window.Modernizr.csstransforms;
      const scriptPath = isModern
        ? "/js/lib/turn.js"
        : "/js/lib/turn.html4.min.js";

      await this.loadScript(scriptPath);
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          return resolve();
        }
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`خطا در لود: ${src}`));
        document.head.appendChild(script);
      });
    },

    runTurnPlugin() {
      const self = this;
      const flipbook = $("#flipbook");

      if (typeof flipbook.turn === "function") {
        flipbook.turn({
          width: 300,
          height: 515,
          elevation: 50,
          gradients: true,
          autoCenter: true,
          display: "single",
          acceleration: true,
          when: {
            turned: function (event, page) {
              self.currentPage = page;
            },
            turning: function (event, page, view) {},
          },
        });
      } else {
        console.error("پلاگین Turn.js لود نشده است.");
      }
    },

    nextPage() {
      $("#flipbook").turn("next");
    },
    prevPage() {
      $("#flipbook").turn("previous");
    },
  },
};
</script>

<style scoped>
@import "./magazine/css/basic.css";

.flipbook-viewport {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 10px 0;
}

#flipbook {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.sheet {
  background-color: white;
  box-shadow: inset -5px 0 10px rgba(0, 0, 0, 0.1);
}

.nav-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 100;
  pointer-events: none;
}

.nav-btn {
  pointer-events: auto;
  margin: 0 5px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.nav-btn:hover {
  opacity: 1;
}

.page-number-indicator {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #666;
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 10px;
  border-radius: 10px;
}
</style>
